export default __webpack_public_path__ + "static/media/person-icon.86e910d3.svg";